import { ModalStaticProperties } from 'components/ModalPortal/ModalPortal';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext, useState } from 'react';
import { ImageCalibrationConfig, Scale } from 'records/MappedSheetVersion';
import { SheetVersion } from 'records/SheetVersion';
import {
  createCalibrationMachine,
  createCalibrationMachineServices,
} from './CalibrationMachine';
import { CalibrationMachineProvider } from './CalibrationMachine/CalibrationMachineContext';
import CalibrationModalContent from './CalibrationModalContent';

type CalibrationModalProps = {
  sheetVersion: SheetVersion;
};

const CalibrationModal: React.FC<CalibrationModalProps> &
  ModalStaticProperties = ({ sheetVersion }: CalibrationModalProps) => {
  const {
    state: appState,
    actions: { createMappedSheetVersion },
  } = useContext(AppStoreContext);

  const { location } = appState.getProject();
  const defaultCenter = { longitude: -98.4895319, latitude: 39.9571288 };
  const projectCenter = location ? location.center : defaultCenter;

  const existingConfig = appState.mappedSheetVersions.get(sheetVersion.pageid)
    ?.imagesource?.calibrationconfig;

  const lastModifiedLayerScale = localStorage.getItem('lastModifiedLayerScale');
  const lastModifiedLayerScaleParsed: Scale | undefined = lastModifiedLayerScale
    ? JSON.parse(lastModifiedLayerScale)
    : undefined;

  const initialConfig = {
    bearing: existingConfig?.bearing,
    centerpoint: existingConfig?.centerpoint,
    corners: existingConfig?.corners,
    croppath: existingConfig?.croppath,
    scale: existingConfig?.scale,
  } as ImageCalibrationConfig;

  const defaultConfig = {
    centerpoint: projectCenter,
    croppath: [],
    bearing: 0,
    scale: lastModifiedLayerScaleParsed,
  };

  const calibrationConfig = existingConfig ? initialConfig : defaultConfig;

  const [calibrationMachine] = useState(() =>
    createCalibrationMachine({
      requiredContext: { sheetVersion, projectCenter, calibrationConfig },
      services: createCalibrationMachineServices({
        createMappedSheetVersion,
      }),
    })
  );

  return (
    <CalibrationMachineProvider calibrationMachine={calibrationMachine}>
      <CalibrationModalContent />
    </CalibrationMachineProvider>
  );
};

export default CalibrationModal;

CalibrationModal.modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
  content: {
    padding: '0px',
    overflow: 'auto',
    borderRadius: '8px',
  },
};
